
















import { Component, Prop, Vue } from "vue-property-decorator";
import __ from "@/shared/helpers/__";
import PageHeader from "@/admin/components/PageHeader.vue";
import Form from "@/shared/components/form/Form.vue";
import FormBase from "@/shared/classes/form/form-base";
import { GlobalActions } from "@/shared/store/global/global.actions";
import Field, { FieldSizes } from "@/shared/classes/form/field";
import { HttpMethod } from "@/shared/helpers/requests.helper";
import { getNodeApiUrlByVersion } from "@/config";
import Course from "@/shared/modules/courses/course.model";
import { SnackBarTypes } from "@/shared/helpers/snack-bar.helper";
import { FieldTypes } from "@/shared/components/form/field-types";

@Component({
  components: { Form, PageHeader },
  methods: { __ },
})
export default class CoursesTestPassingThresholdDialog extends Vue {
  @Prop() meta!: any
  form: FormBase | null = null

  created() {
    this.form = new FormBase()
      .setEntry(this.meta.item)
      .setEndpoint(`${getNodeApiUrlByVersion()}/courses/${this.meta.item.uuid}/additional-info`)
      .setAppendUuidOnSubmit(false)
      .setMethod(HttpMethod.PATCH)
      .setModel(Course)
      .setFields([
        new Field()
          .setKey('testPassingThreshold')
          .setType(FieldTypes.number)
          .setSize(FieldSizes.full)
          .isRequired()
          .setTitle(__('Title')),
      ])
      .setChangeDataBeforeSubmit(data => ({ ...data, testPassingThreshold: Number(data.testPassingThreshold) }))
      .setValidate(true, { onlyRegionLangRequired: true })
      .setOnSuccess(() => {
        this.$store.dispatch(GlobalActions.closeDialog)
        this.$store.dispatch(GlobalActions.showSnackBar, {
          type: SnackBarTypes.success,
          message: __('admin.components.courses.tests.dialogs.on-success'),
        })
        if (typeof this.meta.onSuccess === 'function') this.meta.onSuccess();
      })
  }

  async closeDialog() {
    await this.$store.dispatch(GlobalActions.closeDialog)
  }
}
